import React from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import styles from './CRTEffect.module.css';

export const CRTEffect: React.FC = () => {
  const { settings } = useSettings();

  if (!settings.crtEffect) {
    return null;
  }

  return (
    <div className={styles.crt} aria-hidden="true">
      <div className={styles.scanlines} />
      <div className={styles.flicker} />
    </div>
  );
};

export default CRTEffect;
